import { render, staticRenderFns } from "./cookies-popup.vue?vue&type=template&id=275502c6&scoped=true"
import script from "./cookies-popup.vue?vue&type=script&lang=js"
export * from "./cookies-popup.vue?vue&type=script&lang=js"
import style0 from "./cookies-popup.vue?vue&type=style&index=0&id=275502c6&prod&theme=dark-theater&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275502c6",
  null
  
)

export default component.exports